import styled from 'styled-components';

export const SearchWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
	position: relative;
	background-color: #fff;
  ${down(breakpoints.md)} {
		padding:50px 16px;
		background: none;
}
`
);

export const DestinationContainerWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
		padding: 16px;
		background: #FFFFFF;
		box-shadow: 0px 1px 32px rgba(0, 0, 0, 0.16);
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		position: relative;
		top: -48px;
		width: 100%;
		${down(breakpoints.md)} {
			padding: 0px;
			background: none;
			box-shadow: none;
		}
`
);

export const FilterSection = styled.div`
    padding: 22px 24px;
    background: #FFFFFF;
    box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
